module.exports = __webpack_public_path__ + "img/specialist.96877a54.png";